import { render, staticRenderFns } from "./AnxAlert.vue?vue&type=template&id=51e640fb&scoped=true&"
import script from "./AnxAlert.vue?vue&type=script&lang=ts&"
export * from "./AnxAlert.vue?vue&type=script&lang=ts&"
import style0 from "./AnxAlert.vue?vue&type=style&index=0&id=51e640fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e640fb",
  null
  
)

export default component.exports